import { create } from 'zustand';
import type { User } from '@/types/auth';

interface AuthState {
  user: User | null;
  isLoading: boolean;
  setUser: (u: User | null) => void;
  setLoading: (b: boolean) => void;
  isAdmin: () => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  isLoading: true,
  setUser: (u) => set({ user: u, isLoading: false }),
  setLoading: (b) => set({ isLoading: b }),
  isAdmin: () => get().user?.role === 'admin',
}));
